// extracted by mini-css-extract-plugin
export default {"label":"DisplayData_label__JeNCO"};